import { render, staticRenderFns } from "./JuarezLeite.vue?vue&type=template&id=4356ea18&scoped=true"
import script from "./JuarezLeite.vue?vue&type=script&lang=js"
export * from "./JuarezLeite.vue?vue&type=script&lang=js"
import style0 from "./JuarezLeite.vue?vue&type=style&index=0&id=4356ea18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356ea18",
  null
  
)

export default component.exports